import store from "@/state/store";

export default [
  {
    path: "/",
    name: "dashboard",
    component: () => import("./views/dashboard"),
    beforeEnter: (to, from, next) => {
      setTimeout(() => {
        next();
      }, 500);
    },
  },
  {
    path: "/dashboard-old",
    name: "dashboardTest",
    component: () => import("./views/dashboardOld"),
    beforeEnter: (to, from, next) => {
      setTimeout(() => {
        next();
      }, 500);
    },
  },
  // login
  {
    path: "/login/:passport_id?",
    name: "login",
    component: () => import("./views/account/login"),
    beforeEnter: (routeTo, routeFrom, next) => {
      next();
    },
    meta: {},
  },
  // sign up selector
  {
    path: "/register-selector",
    name: "SignupSelector",
    component: () => import("./views/account/SignupSelector"),
    meta: {},
  },
  // register
  {
    path: "/register",
    name: "Register",
    component: () => import("./views/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (routeTo.query.mac && localStorage.user) {
          localStorage.setItem("mac", routeTo.query.mac);
          localStorage.setItem("serial", routeTo.query.serial);
          // Redirect to the home page instead
          next({ name: "Dashboard" });
        } else {
          next();
        }
      },
    },
  },
  // passport register
  {
    path: "/register-passport",
    name: "PassportRegister",
    component: () => import("./views/account/PassportRegisteration"),
    meta: {},
  },
  // success register
  {
    path: "/success-register",
    name: "SuccessRegister",
    component: () => import("./views/WebForms/SuccessRegister"),
    meta: {},
  },
  // success email
  {
    path: "/success-email",
    name: "SuccessEmail",
    component: () => import("./views/WebForms/SuccessEmail"),
    meta: {},
  },
  // success email
  {
    path: "/success-sms",
    name: "SuccessSMS",
    component: () => import("./views/WebForms/SuccessSMS"),
    meta: {},
  },
  // forget password
  {
    path: "/forget-password",
    name: "ForgetPassword",
    component: () => import("./views/account/ForgetPassword"),
    meta: {
      authRequired: false,
    },
  },
  // logout
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch("authfack/logout", routeTo.query.email);
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute
            ? { name: "/dashboard" }
            : { ...routeFrom }
        );
      },
    },
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("./views/admin"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/dashboard/:user_id?/:entity_id?/:server_id?/:enc_pwd?/:enc_email?/:code?/:passportQr?",
    name: "Dashboard",
    component: () => import("./views/dashboard"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/quick-pass",
    name: "QuickPass",
    component: () => import("./views/quickpass"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/qp",
    name: "QuickPass2",
    component: () => import("./views/quickpass"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/reset-password/:token?/:email?",
    name: "Reset password",
    component: () => import("./views/account/reset-password"),
    meta: {
      auth: false,
      authRequired: false,
    },
  },
  {
    path: "/verify-otp-code",
    name: "confirmVericationCode",
    component: () => import("./views/account/ConfirmVerificationCode"),
    meta: {
      authRequired: true,
    },
    // beforeEnter: (routeTo, routeFrom, next) => {
    //   const loggeduser = localStorage.getItem("user");
    //   const userOtpRequired = localStorage.getItem('userOtpRequired') ? parseInt(localStorage.getItem('userOtpRequired')) : 0;
    //   const userIsVerified = localStorage.getItem('userIsVerified') ? parseInt(localStorage.getItem('userIsVerified')) : 0;
  
    //   if (loggeduser && userOtpRequired && userIsVerified) {
    //     // console.log('bbb');
    //     return next("/");
    //   }
    //   next();
    // },
  },
  // sorry page
  {
    path: "/error-revoked",
    name: "SorryPage",
    meta: {
      authRequired: true,
    },
    component: () => import("../components/sorryPage/SorryPage"),
  },
  {
    path: "/upload-image",
    name: "uploadImage",
    meta: {
      authRequired: true,
    },
    component: () => import("@/router/views/account/upload-image.vue"),
  },
  {
    path: "/login-one-time/:hashedEmail/:code",
    name: "loginOneTimeSSO",
    meta: {
      authRequired: false,
    },
    beforeEnter(routeTo, routeFrom, next) {
      // console.log('paramsss', routeTo.params);
      store
        .dispatch("authfack/verifyOneTimeCode", {
          username: routeTo.params.hashedEmail,
          oneTimeCode: routeTo.params.code,
          encrypted: true,
        })
        .then(() => {
          if (routeTo.query.area_id || routeTo.query.add_visitor) {
            next({
              name: "dashboard", query: {
                ...routeTo.query
              },
            });
            // store
            //   .dispatch(
            //     "preRegistrationState/getAreaDetails",
            //     routeTo.query.entity_id
            //   )
            //   .then((area) => {
            //     console.log(area);
            //     console.log(user);
            //   });
          } else {
            next({ name: "dashboard" });
          }
        })
        .catch((err) => {
          if (err.response?.data?.message == "Link expired") {
            next({ name: "oneTimeLinkExpired" });
          }
        });
    },
  },
  {
    path: "/login-one-time/:hash",
    name: "magicLink",
    meta: {
      authRequired: false,
    },
    beforeEnter(to, from, next) {
      console.log(to.query);
      let decodedParams = atob(to.params.hash);
      const url = new URL(decodedParams, window.location.href);
      console.log(url);
      let query = {};
      for (const [key, value] of url.searchParams.entries()) {
        query[key] = value;
      }
      let [encodedEmail, oneTimeCode] = url.pathname.split("/").splice(2);
      store
        .dispatch("authfack/verifyOneTimeCode", {
          username: encodedEmail,
          oneTimeCode: oneTimeCode,
          encrypted: true,
        })
        .then((user) => {
          if (query.redirect_url) {
            query.passport_id = user.data.data.user.id;
            if (user.data.data.user.image) {
              url.searchParams.set("image", user.data.data.user.image);
            }
            url.searchParams.set("first_name", user.data.data.user.first_name);
            url.searchParams.set("last_name", user.data.data.user.last_name);
            let new_url = new URL(
              "?" + url.searchParams.toString(),
              query.redirect_url
            );
            window.location = new_url;
          } else {
            next({ name: "dashboard" });
          }
        });
    },
  },
  // verify login code
  {
    path: "/login-code/:visitUrl/:code",
    name: "verifyLogin",
    meta: {
      authRequired: false,
    },
    beforeEnter(routeTo) {
      // console.log('paramsss', routeTo.params);
      store
        .dispatch("authfack/verifyLoginCode",
          { code: routeTo.params.code, visitUrl: routeTo.params.visitUrl },
        );
    },
  },
  {
    path: "/login-one-time",
    name: "loginOneTime",
    meta: {
      authRequired: false,
    },
    component: () => import("@/router/views/account/oneTimeLogin.vue"),
  },
  {
    path: "/link-expired",
    name: "oneTimeLinkExpired",
    meta: {
      authRequired: false,
    },
    component: () => import("@/router/views/account/oneTimeLinkExpired.vue"),
  },
  {
    path: "/compliance-link-expired",
    name: "complianceLinkExpired",
    meta: {
      authRequired: false,
    },
    component: () => import("@/router/views/account/oneTimeLinkExpired.vue"),
  },
];
